import React from 'react';
import {useErrorBoundary} from 'react-error-boundary';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  Rotate90Icon,
} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';

type ErrorFallbackProps = {
  error: Error & {
    showRefresh?: boolean;
  };
};

const ErrorFallback = ({error}: ErrorFallbackProps) => {
  const {resetBoundary} = useErrorBoundary();
  const {t} = useTranslation('*');

  let showRefresh = true;
  if (Object.prototype.hasOwnProperty.call(error, 'showRefresh') && !error.showRefresh) {
    showRefresh = false;
  }

  console.log(error.message, error.cause);

  const dialogTitle = error?.name ? error.name : 'Error' + (error.cause ? ` (${error.cause})` : '');

  return (
    <Dialog
      open={true}
      displayMode="modal"
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={dialogTitle}
      aria-live="assertive"
    >
      <DialogContent>
        <div>{error?.message ? error.message : (error as any)}</div>
      </DialogContent>
      <DialogFooter isSmallScreen={false}>
        {showRefresh && (
          <Button
            onClick={resetBoundary}
            buttonStyle="primary"
            label={t('*:str_LabelReset')}
            startIcon={<Rotate90Icon />}
            size="small"
          />
        )}
      </DialogFooter>
    </Dialog>
  );
};

export default ErrorFallback;
